import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=d5e17988&"
import script from "./SvgIcon.vue?vue&type=script&lang=ts&"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
